export type LogLevel = "debug" | "info" | "warn" | "error" | "none";
const order: Record<LogLevel, number> = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3,
  none: 4,
};
const noop = () => {};

export class Logger {
  constructor(
    private name: string,
    private logLevel: LogLevel = "error",
  ) {}

  private enabled(l: LogLevel) {
    return order[l] >= order[this.logLevel];
  }

  get debug() {
    return this.enabled("debug")
      ? console.debug.bind(console, `[${this.name}]`)
      : noop;
  }
  get info() {
    return this.enabled("info")
      ? console.info.bind(console, `[${this.name}]`)
      : noop;
  }
  get warn() {
    return this.enabled("warn")
      ? console.warn.bind(console, `[${this.name}]`)
      : noop;
  }
  get error() {
    return this.enabled("error")
      ? console.error.bind(console, `[${this.name}]`)
      : noop;
  }
}
